import * as types from './types';

const init = () => ({
  type: types.INIT,
});

const setup = () => ({
  type: types.SETUP,
});

const setSelectedBar = (value, index) => ({
  type: types.SET_SELECTED_BAR,
  value,
  index,
});

export {
  init,
  setup,
  setSelectedBar,
};
